"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIN_UNIQUE_MARKED_ANSWERS_FOR_CLASSIFICATION = exports.DIFFICULTY_THRESHOLD = exports.SERVICE_NAME = void 0;
// Used by other services to reference this one in the dependency map
exports.SERVICE_NAME = 'short-answer-service';
exports.DIFFICULTY_THRESHOLD = 0.4;
exports.MIN_UNIQUE_MARKED_ANSWERS_FOR_CLASSIFICATION = 300;
__exportStar(require("./answer"), exports);
__exportStar(require("./classifier"), exports);
__exportStar(require("./stop-words"), exports);
__exportStar(require("./spell-check-words"), exports);
__exportStar(require("./supported-languages"), exports);
__exportStar(require("./question"), exports);
//# sourceMappingURL=index.js.map